import { POISearchRepository } from '@/models/POI/POISearchRepository'

const actions = {
  async SET_SIMULATION_LOCATION_GROUPS(
    { commit },
    { customLocationGroups, poiLocationGroups },
  ) {
    // poiLocationGroups の地点を取得
    await Promise.all(
      poiLocationGroups.map(async poiLocationGroup => {
        poiLocationGroup.simulationLocations = await POISearchRepository.getPoiLocationList(
          poiLocationGroup.categoryId,
          poiLocationGroup.conditions,
          poiLocationGroup.administrativeDistrictType,
          poiLocationGroup.area,
        )
      }),
    )

    /** idで取得しやすいようにMap型に変換する */
    const customLocationGroupMap = convertLocationGroupsToMap(
      customLocationGroups,
    )
    const poiLocationGroupMap = convertLocationGroupsToMap(poiLocationGroups)

    const mergedLocationGroupMap = new Map([
      ...customLocationGroupMap,
      ...poiLocationGroupMap,
    ])

    commit('SET_SIMULATION_LOCATION_GROUPS', mergedLocationGroupMap)
  },
  SET_LOCATION_LIST_COUNT({ commit }, locationListCount) {
    commit('SET_LOCATION_LIST_COUNT', locationListCount)
  },
}

export default actions

const convertLocationGroupsToMap = locationGroups => {
  return locationGroups.reduce((map, group) => {
    map.set(group.id, group.simulationLocations)
    return map
  }, new Map())
}
